import {
	EnhancedButtonPrimeReact,
	EnhancedButtonPrimeReactSeverity,
	EnhancedDropDownRHF,
	EnhancedDropDownRHFWithLabel,
	LabelPosition,
	RHookFormDatePicker,
	RHookFormNumberFieldWithLabel,
} from "@websential/cosmic-v20";
import { Grid, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";

import { Link } from "react-router-dom";


interface IRQReportHeader {
	companySavedRemittance: null | { label: string, value: string };
	// salaryProfileReportDDlItems?: { label: string; value: any }[];
	onViewSelectionChangeHandler: (selected: number) => void;
	// onEmployeeStatusSelectionChangeHandler: (params: any) => void;
	// selectedItem: any
}

export const RQReportHeader: React.FC<
	IRQReportHeader
> = ({ companySavedRemittance, onViewSelectionChangeHandler }) => {

	// const [showDateRange, setShowDateRange] = useState(200);
	// const handleShowDateRangeChange = (e: any) => {
	// 	setShowDateRange(e.value);
	// };

	return (
		<>
			<Grid
				container
				size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}
				sx={{
					background: "#fff",
					border: "1px solid #e5e7eb",
					borderBottom: 0,
					borderRadius: "2px 2px 0 0",
					padding: "31px 20px 2.5rem 20px",
					marginBottom: "0px!important",
					fontSize: "0.875rem",
				}} columnSpacing={2}>
				<Grid
					size={{ xs: 12, sm: 12, md: 2, lg: 2, xl: 2 }}
					sx={{
						fontSize: "0.875rem",
						color: "#4b5563",
						"& .dropDownWrapper": { marginBottom: "15px!important" },
					}}>
					{/* <EnhancedDropDownRHFWithLabel
						selectName="showReport"
						testId={`show-report-rq`}
						items={[
							{ label: "Summarize", value: 100 },
							{ label: "Weekly", value: 200 },
						]}
						selectedItem={100}
						label="Show Report"
					// selectedItem={remittanceFrequencyDDL && remittanceFrequencyDDL[0].value}
					// onSelectionChangeHandler={onRemittanceFrequencyChangeHandler}
					/> */}
					<EnhancedDropDownRHFWithLabel
						selectName="view"
						testId="view-rq"
						items={[
							{ label: "Payment Date", value: 200 },
							{ label: "End Date", value: 100 },
						]}
						selectedItem={200}
						label="View"
						onSelectionChangeHandler={onViewSelectionChangeHandler}
					/>
					{companySavedRemittance && <Typography
						sx={{
							fontSize: "0.875rem",
							color: "#4b5563",
						}}
					>
						Quebec Remittance
						<Link to={"#"}
							className="no-underline"
						><span style={{ color: "#0091b3", fontSize: "0.875rem" }}>&nbsp;{companySavedRemittance && companySavedRemittance.label}</span></Link>
					</Typography>}

				</Grid>
			</Grid>
		</>
	);
};
